<template>
    <div class="template-dropdown-widget">
        <div class="dropdown-widget-header" @click="switchDropdown()" ref="template-dropdown-widget">
            <div class="dropdown-widget-header-title">
                <span>{{ selecteValue }}</span>
            </div>
            <div class="dropdown-widget-header-actions">
                <div class="dropdown-widget-header-action">
                    <img v-if="!show_dropdown" src="@/assets/icons/allow-down.svg">
                    <img v-else src="@/assets/icons/allow-up.svg">
                </div>
            </div>
        </div>
        <div class="dropdown-widget-body" v-if="show_dropdown" v-closable="{
            exclude: ['template-dropdown-widget'],
            handler: 'closeDropdown',
        }">
            <div class="dropdown-widget-body-item" v-for="(option, index) in options" :key="index"
                :class="{ active: option.value == value }" @click="selectItem(option)">
                <div class="dropdown-widget-body-item-label">
                    {{ option.label }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { eventBus } from "@/main";
export default {
    name: "editor-property",
    components: {

    },
    props: {
        placeholder: {
            type: String,
            default: "Select",
        },
        value: {
            type: String,
            default: "",
        },
        options: {
            type: Array,
            default: () => [],
            required: true,
        },
    },
    data() {
        return {
            show_dropdown: false,
        };
    },

    mounted() {
        let vm = this;

    },
    computed: {
        selecteValue() {
            let selected = this.options.find((item) => item.value == this.value);
            return selected ? selected.label : this.placeholder;
        },
    },
    methods: {
        selectItem(item) {
            this.show_dropdown = false;
            this.$emit("input", item.value);
        },
        switchDropdown() {
            this.show_dropdown = !this.show_dropdown;
        },
        closeDropdown() {
            this.show_dropdown = false;
        },
    },
};
</script>
  
<style lang="scss" scoped>
$assets: "~@/assets";

.template-dropdown-widget {
    display: flex;
    position: relative;
    width: max-content;

    .dropdown-widget-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        height: 30px;
        width: 100%;
        border: 1px solid #e9e9e9;
        padding: 0px 10px;
        background-color: #ffffff;
        border-radius: 5px;

        .dropdown-widget-header-title {
            margin-right: 5px;
            display: flex;
            width: calc(100% - 20px);

            span {
                margin: 0;
                display: block;
                width: 100%;
                overflow: hidden;
                text-decoration: none;
                text-overflow: ellipsis;
                white-space: nowrap;

            }
        }

        .dropdown-widget-header-actions {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 15px;

            .dropdown-widget-header-action {
                img {
                    width: 10px;
                }
            }
        }
    }

    .dropdown-widget-body {
        position: absolute;
        top: 30px;
        width: 100%;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
        background-color: #ffffff;
        border-radius: 5px;
        z-index: 9999;
        max-height: 200px;
        overflow-y: auto;

        .dropdown-widget-body-item {
            padding: 10px;
            cursor: pointer;

            &:hover {
                background-color: #f4f4f4;
            }

            &.active {
                background-color: #f4f4f4;
            }

            .dropdown-widget-body-item-label {
                margin: 0;
            }
        }
    }

    &.no-border {
        .dropdown-widget-header {
            border: none;

            .dropdown-widget-header-title {

                span {
                    color: #0884AF;
                }
            }
        }
    }
}
</style>